import styled from 'styled-components'
import { theme } from 'utils/style'
import Block from 'components/Block/Block'

export const Error = styled(Block)`
  margin: 0.5rem 0 0;
  font-size: ${theme('fonts.size.s')};
  background: none;
  color: ${theme('colors.danger')};
`
